import axios from 'axios';

export const clientContactApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-contact`,
    headers: {
        'Content-Type': 'application/json'
    }
})